<template>
  <div class="w1200">
    <!-- <div class="lottery">
        <span
            v-for="(item, index) in lottery.arr"
            :key="index"
            :class="lottery.active == index ? 'active' : ''"
            @click="lottery.active = index"
            >{{ item }}</span
        >
    </div> -->
    <div class="lottery">
            <span v-for="(item,index) in lottery.db"
                  :key="index"
                  :class="{active:lottery.index == index,}"
                  @click="lottery.index = index;lottery.active = item.dictValue;getList();">
              {{ item.dictLabel }}
            </span>
    </div>

    <div class="type">
      <div>
                <span
                    v-for="(item, index) in type.arr"
                    :key="index"
                    :class="type.active == index ? 'active' : ''"
                    @click="type.active = index;getList()">
                  {{ item.label }}
                </span>
      </div>
      <span @click="gotoApplytrade">申请软件交易师</span>
    </div>

    <div class="table">

      <div class="head">
         <span> {{ lottery.db[lottery.index].dictLabel }}软件交易汇总</span>
      </div>

      <el-table v-if="type.active == 0"
                :data="tableData"
                border style="width: 100%"
                :cell-style="{'text-align':'center'}"
                :header-cell-style="{background:'#DBDBDB',color:'#000','text-align':'center'}"
      >
        <el-table-column type="index" label="序号" width="50">
          <template slot-scope="scope">
            <template v-if="scope.$index <= 2">
              <img v-if="scope.$index == 0"
                   src="@/assets/common/rank/1.gif">
              <img v-if="scope.$index == 1"
                   src="@/assets/common/rank/2.gif">
              <img v-if="scope.$index == 2"
                   src="@/assets/common/rank/3.gif">
            </template>
            <template v-else>
              {{ scope.$index + 1 }}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="softDealer" label="软件交易师" width="180"/>
        <el-table-column prop="hits" :show-overflow-tooltip="true" label="点击量"/>
        <el-table-column prop="softName" :show-overflow-tooltip="true" label="软件名称"/>
        <el-table-column prop="intro" :show-overflow-tooltip="true" label="软件简介"/>
        <el-table-column prop="noVirus" :show-overflow-tooltip="true" label="发布者是否杀毒处理" width="160">
          <template slot-scope="scope">
            {{ scope.row.noVirus == 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="softwareSourceIntro" :show-overflow-tooltip="true" label="软件来源"/>
        <el-table-column prop="address" :show-overflow-tooltip="true" label="请平台技术再杀毒">
          在杀毒10缩币
        </el-table-column>
        <el-table-column prop="updateTime" :show-overflow-tooltip="true" label="发布时间"/>
      </el-table>

      <el-table v-if="type.active == 1"
                :data="tableData"
                border style="width: 100%"
                :cell-style="{'text-align':'center'}"
                :header-cell-style="{background:'#DBDBDB',color:'#000','text-align':'center'}"
      >
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="softDealer" label="软件交易师" width="180"/>
        <el-table-column prop="softName" :show-overflow-tooltip="true" label="软件名称"/>
        <el-table-column prop="intro" :show-overflow-tooltip="true" label="软件简介"/>
        <el-table-column prop="address" :show-overflow-tooltip="true" label="是否做过杀毒处理">
          <template slot-scope="scope">
            {{ scope.row.noVirus == 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="softwareSourceIntro" :show-overflow-tooltip="true" label="软件来源"/>
        <el-table-column prop="address" :show-overflow-tooltip="true" label="免费维护期"/>
        <el-table-column prop="updateTime" :show-overflow-tooltip="true" label="发布时间"/>
      </el-table>

      <el-table v-if="type.active == 2"
                :data="tableData"
                border style="width: 100%"
                :cell-style="{'text-align':'center'}"
                :header-cell-style="{background:'#DBDBDB',color:'#000','text-align':'center'}"
      >
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="date" label="软件定制人" width="180"/>
        <el-table-column prop="name" label="申请定制时间" width="180"/>
        <el-table-column prop="address" :show-overflow-tooltip="true" label="定制软件的功能和需求说明"/>
        <el-table-column prop="address" :show-overflow-tooltip="true" label="定制模式"/>
        <el-table-column prop="address" :show-overflow-tooltip="true" label="平台推荐开发团队划定工期和工价"
                         width="135"/>
        <el-table-column prop="address" :show-overflow-tooltip="true" label="定制状态"/>
        <el-table-column prop="address" :show-overflow-tooltip="true" label="定制人托管任务保障金（锁定资金）"
                         width="135"/>
        <el-table-column prop="address" :show-overflow-tooltip="true" label="开发团队启动开发工作"/>
        <el-table-column prop="address" :show-overflow-tooltip="true" label="定制人验收"/>
      </el-table>

      <!-- <div class="pagination">
          <el-pagination
          background
          layout="total,prev, pager, next"
          :total="1000">
          </el-pagination>
      </div> -->

      <el-pagination style="padding-top:20px;text-align:right"
                     background
                     layout="prev, pager, next"
                     @current-change="changePage"
                     :page-size="listPagin.limit"
                     :total="listPagin.total">
      </el-pagination>

    </div>

  </div>
</template>

<script>
import {queryLotteryType} from "@/api/common"
import {softwareList} from '@/api/home'

export default {
  data() {
    return {
      lottery: {
        db: [],
        active: '0',
        index: 0
      },
      listPagin: {
        page: 1,
        limit: 1,
        total: 0
      },
      type: {
        // 软件分类 FREE：免费厅 PAID_TRANSFER：有偿转让厅 CUSTOM：定制软件厅
        arr: [
          {label: '免费厅', value: 'FREE'},
          {label: '有偿转让厅', value: 'PAID_TRANSFER'},
          {label: '定制软件厅', value: 'CUSTOM'},
        ],
        active: 0,
      },
      tableData: [],


    };
  },
  mounted() {

    // 获取彩种
    queryLotteryType().then(res => this.lottery.db = res.data.map(item => {
      return {dictLabel: item.dictLabel, dictValue: item.dictValue}
    }))

    this.getList()
  },
  methods: {
    getList() {
      softwareList({
        preType: this.lottery.active,
        softwareSource: '',
        classification: this.type.arr[this.type.active].value,
        pageNumber: this.listPagin.page,
        pageSize: this.listPagin.limit
      }).then(res => {
        console.log("res",res);
        let {rows, total} = res;
        this.tableData = rows
        this.listPagin.total = total
      })
    },
    // 分页状态变化
    changePage(e) {
      this.listPagin.page = e;
      this.getList()
    },
    // 申请软件交易师
    gotoApplytrade() {
      this.$router.push('/personalCenter/suoshuiruanjian/apply_jys')
    }
  }
};
</script>

<style lang="scss" scoped>
.lottery {
  margin: 10px 0;

  span {
    display: inline-block;
    padding: 20px 30px;
    background-color: #dbdbdb;
    cursor: pointer;

    &.active {
      background-color: #93D2F3;
      color: #000;
    }
  }
}

.type {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  margin: 20px 0;

  > div {
    span {
      display: inline-block;
      padding: 5px 30px;
      border: 1px solid #999;
      margin-right: 10px;
      border-radius: 10px;
      background-color: #dbdbdb;
      cursor: pointer;

      &.active {
        background-color: #93d2f3;
      }
    }
  }

  > span {
    border: 1px solid #999;
    padding: 5px 20px;
    border-radius: 20px;
    cursor: pointer;
  }
}

.table {
  .head {
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 5px solid #3f7bae;


    span {
      display: inline-block;
      padding: 0 20px;
      color: #3f7bae;
      font-weight: bold;
      font-size: 20px;
    }
  }

  .pagination {
    margin: 30px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>